import React from 'react';
import Overlay from '../../Overlay';

const ErrorLayout = ({account, event, error}) => {
    const content = (<div>{error}</div>);
    const attrs = {account, content};
    return (<Overlay {...attrs} />);
};

export default ErrorLayout;